export const TA = [
	{
		"_id": "63e5152607ae8ddb2a98a529",
		"address": "Cesaria Israel",
		"agencyName": "VillaTracker",
		"agency_id": 1,
		"country": "Israel",
		"countryCode": "IL",
		"createdAt": "2023-01-20T17:24:19.491Z",
		"email": "tal@smilinghouse.ch",
		"firstName": "Moriya",
		"lastName": "Rockman",
		"phone": "5234309432",
		"updatedAt": "2023-03-29T07:12:06.339Z",
		"userImage": "http://localhost:8080/uploads/agency_image-1674235459399.PNG"
	},
	{
		"_id": "63e5152607ae8ddb2a98a52a",
		"address": "Gstaad",
		"agencyName": "VillaTracker",
		"agency_id": 2,
		"country": "Swizerland",
		"countryCode": "CH",
		"createdAt": "2023-01-20T17:24:19.491Z",
		"email": "smilingcloud21@gmail.com",
		"firstName": "Einav",
		"lastName": "Silner",
		"organization": "ISSTA",
		"phone": "52904954999",
		"updatedAt": "2023-03-29T07:12:06.339Z",
		"userImage": "http://localhost:8080/uploads/agency_image-1674235459399.PNG"
	},
	{
		"_id": "63e5152607ae8ddb2a98a52b",
		"address": "Tivon Israel",
		"agencyName": "VillaTracker",
		"agency_id": 3,
		"country": "France",
		"countryCode": "FR",
		"createdAt": "2023-01-20T17:24:19.491Z",
		"email": "meir.bond@gmail.com",
		"firstName": "Meir",
		"lastName": "Bond",
		"organization": "ISSTA",
		"phone": "43058430958",
		"updatedAt": "2023-03-29T07:12:06.339Z"
	},
	{
		"_id": "63e5152607ae8ddb2a98a52c",
		"abbreviation": "TA1",
		"address": "Whole Street 12",
		"agencyName": "Smiling House -  10%",
		"agency_id": 29,
		"city": "Saanen",
		"countryCode": "CH",
		"createdAt": "2023-01-20T17:24:19.491Z",
		"email": "ira@smilingflats.com",
		"firstName": "Test",
		"phone": "41254875896",
		"ta_company_markup": "10",
		"updatedAt": "2023-03-29T07:12:06.340Z",
		"website": "www.travelagency1.com"
	},
	{
		"_id": "63e5152607ae8ddb2a98a52d",
		"abbreviation": "SA",
		"address": "22 sunset blvd",
		"agencyName": "Supreme Travel Inc.",
		"agency_id": 30,
		"city": "Tel Aviv",
		"countryCode": "US",
		"createdAt": "2023-01-20T17:24:19.491Z",
		"email": "idobeny@gmail.com",
		"firstName": "Ido",
		"phone": "+1 818 66 54 367",
		"state_province": "californial",
		"ta_company_markup": "15",
		"updatedAt": "2023-03-29T07:12:06.340Z"
	},
	{
		"_id": "63e5152607ae8ddb2a98a52e",
		"abbreviation": "Gen1",
		"address": "28 Rishonim rd.",
		"agencyName": "Genesis",
		"agency_id": 31,
		"city": "Tel Aviv",
		"countryCode": "IL",
		"createdAt": "2023-01-20T17:24:19.491Z",
		"email": "idobeny@gmail.com",
		"firstName": "Elvis",
		"ta_company_markup": "13",
		"updatedAt": "2023-03-29T07:12:06.340Z"
	},
	{
		"_id": "63e5152607ae8ddb2a98a52f",
		"abbreviation": "GmbH",
		"address": "Dechaneistraße 30",
		"agencyName": "Frosch Ferienhaus",
		"agency_id": 32,
		"city": "Münster",
		"countryCode": "DE",
		"createdAt": "2023-01-20T17:24:19.491Z",
		"email": "Stefan.Richter@frosch-ferienhaus.de",
		"firstName": "Stefan Richter",
		"phone": "+49 (0)251 899 05-60",
		"ta_company_markup": "0",
		"updatedAt": "2023-03-29T07:12:06.340Z",
		"website": "www.frosch-ferienhaus.de"
	},
	{
		"_id": "63e5152607ae8ddb2a98a530",
		"abbreviation": "SA",
		"address": "Rua das Amoreiras",
		"agencyName": "Tripwix, Vacation Rentals",
		"agency_id": 33,
		"city": "Lisbon",
		"countryCode": "PT",
		"createdAt": "2023-01-20T17:24:19.491Z",
		"email": "properties@tripwix.com",
		"firstName": "Deborah Buley",
		"phone": "+44 778 0867 149",
		"ta_company_markup": "0",
		"updatedAt": "2023-03-29T07:12:06.341Z",
		"website": "www.tripwix.com"
	},
	{
		"_id": "63e5152607ae8ddb2a98a531",
		"abbreviation": "SA",
		"agencyName": "Essentialist",
		"agency_id": 34,
		"city": "Palma De Mallorca",
		"countryCode": "ES",
		"createdAt": "2023-01-20T17:24:19.491Z",
		"email": "catarina.whiteman@essentialist.com",
		"firstName": "Catarina Whiteman",
		"phone": "+1 917-794-2929",
		"ta_company_markup": "0",
		"updatedAt": "2023-03-29T07:12:06.341Z",
		"website": "essentialist.com"
	},
	{
		"_id": "63e5152607ae8ddb2a98a532",
		"abbreviation": "SA",
		"address": "21 Boulevard Général Vautrin",
		"agencyName": "Escales International",
		"agency_id": 35,
		"city": "Cannes",
		"countryCode": "FR",
		"createdAt": "2023-01-20T17:24:19.491Z",
		"email": "gitte.harder@escales.co",
		"firstName": "Gitte Harder",
		"phone": "+ (33) 6 79 93 00 11",
		"ta_company_markup": "0",
		"updatedAt": "2023-03-29T07:12:06.341Z",
		"website": "www.escales.co"
	},
	{
		"_id": "63e5152607ae8ddb2a98a533",
		"abbreviation": "Ltd",
		"address": "3 Gower Street",
		"agencyName": "MVC Rentals",
		"agency_id": 36,
		"city": "London",
		"countryCode": "GB",
		"createdAt": "2023-01-20T17:24:19.491Z",
		"email": "office@massimovillas.com",
		"firstName": "Massimo Provenza",
		"phone": "+44 (0)203 514 6963",
		"ta_company_markup": "0",
		"updatedAt": "2023-03-29T07:12:06.341Z",
		"website": "www.massimovillas.com"
	},
	{
		"_id": "63e5152607ae8ddb2a98a534",
		"abbreviation": "SRL",
		"address": "Via Pietro Calvi 20",
		"agencyName": "Onirikos",
		"agency_id": 37,
		"city": "Milano",
		"countryCode": "IT",
		"createdAt": "2023-01-20T17:24:19.491Z",
		"email": "isabella.bertani@onirikos.com",
		"firstName": "Isabella Bertani",
		"phone": "+39 02 9167 2271",
		"ta_company_markup": "0",
		"updatedAt": "2023-03-29T07:12:06.341Z",
		"website": "www.onirikos.com"
	},
	{
		"_id": "63e5152607ae8ddb2a98a535",
		"abbreviation": "SA",
		"address": "Avenida Arias Maldonado 16",
		"agencyName": "Skol Apartments Marbella",
		"agency_id": 38,
		"city": "Marbella",
		"countryCode": "ES",
		"createdAt": "2023-01-20T17:24:19.491Z",
		"email": "info@marbellaholidays.es",
		"firstName": "Daniela + Vincenzo",
		"phone": "0034 649 999 867",
		"state_province": "Málaga",
		"ta_company_markup": "0",
		"updatedAt": "2023-03-29T07:12:06.342Z",
		"website": "www.skolapartmentsmarbella.com"
	},
	{
		"_id": "63e5152607ae8ddb2a98a536",
		"abbreviation": "Ltd",
		"address": "Herzilia Marina",
		"agencyName": "Sigma Yacht Charters",
		"agency_id": 39,
		"city": "Herzilia",
		"countryCode": "IL",
		"createdAt": "2023-01-20T17:24:19.491Z",
		"email": "sigmayachts@gmail.com",
		"firstName": "Jeremy Antony Azulay",
		"phone": "972-3-6344480",
		"ta_company_markup": "0",
		"updatedAt": "2023-03-29T07:12:06.342Z",
		"website": "www.sigmayachts.com"
	},
	{
		"_id": "63e5152607ae8ddb2a98a537",
		"abbreviation": "Ltd",
		"address": "3243 Av Moishe",
		"agencyName": "Kosher World wide",
		"agency_id": 40,
		"city": "Boisbriand",
		"countryCode": "CA",
		"createdAt": "2023-01-20T17:24:19.491Z",
		"email": "yesh@bookworldreserve.com",
		"firstName": "Yesh Kraus",
		"phone": "15145763403",
		"state_province": "Quebec",
		"ta_company_markup": "0",
		"updatedAt": "2023-03-29T07:12:06.342Z",
		"website": "Dormisuites.com"
	},
	{
		"_id": "63e5152607ae8ddb2a98a538",
		"abbreviation": "SARL-S",
		"address": "7, Bisserweg",
		"agencyName": "Arca Properties SARL",
		"agency_id": 41,
		"city": "Luxembourg",
		"countryCode": "LU",
		"createdAt": "2023-01-20T17:24:19.491Z",
		"email": "Arcaonline1@gmail.com",
		"firstName": "Giacomo Trenz",
		"phone": "00352 691 299 499",
		"ta_company_markup": "0",
		"updatedAt": "2023-03-29T07:12:06.342Z"
	},
	{
		"_id": "63e5152607ae8ddb2a98a539",
		"abbreviation": "INC",
		"address": "95Merrick Way, 3rd floor",
		"agencyName": "ProtocoloTours",
		"agency_id": 42,
		"city": "CoralGables",
		"countryCode": "US",
		"createdAt": "2023-01-20T17:24:19.491Z",
		"email": "info@protocolotours.com",
		"firstName": "Carolina Rojas",
		"phone": "3054960092",
		"state_province": "FL",
		"ta_company_markup": "0",
		"updatedAt": "2023-03-29T07:12:06.342Z",
		"website": "www.protocolotours.com"
	},
	{
		"_id": "63e5152607ae8ddb2a98a53a",
		"abbreviation": "INC",
		"address": "4445 north 36th street 317",
		"agencyName": "HomeSlice Stays",
		"agency_id": 43,
		"city": "Phoenix",
		"countryCode": "US",
		"createdAt": "2023-01-20T17:24:19.491Z",
		"email": "ellie_x7lyjvv@user.guesty.com",
		"firstName": "Ellie Paget",
		"phone": "1 (360) 674-6588",
		"state_province": "Arizona",
		"ta_company_markup": "0",
		"updatedAt": "2023-03-29T07:12:06.342Z",
		"website": "homeslicestays.com"
	},
	{
		"_id": "63e5152607ae8ddb2a98a53b",
		"abbreviation": "SA",
		"address": "2 Robertson Road",
		"agencyName": "TOP SNOW TRAVEL",
		"agency_id": 44,
		"city": "Newport",
		"countryCode": "AU",
		"createdAt": "2023-01-20T17:24:19.491Z",
		"email": "gilles@topsnow.com.au",
		"firstName": "GIL LES RIOU",
		"phone": "61290420522",
		"state_province": "NSW",
		"ta_company_markup": "0",
		"updatedAt": "2023-03-29T07:12:06.342Z",
		"website": "https://www.topsnowtravel.com.au/"
	},
	{
		"_id": "63e5152607ae8ddb2a98a53c",
		"abbreviation": "Ltd",
		"address": "1537 50th St",
		"agencyName": "Plan-IT Israel Travel",
		"agency_id": 45,
		"city": "Brooklyn",
		"countryCode": "US",
		"createdAt": "2023-01-20T17:24:19.491Z",
		"email": "yossi@planitisrael.com",
		"firstName": "Joseph Landau",
		"phone": "7183609445",
		"state_province": "NY",
		"ta_company_markup": "0",
		"updatedAt": "2023-03-29T07:12:06.349Z"
	},
	{
		"_id": "63e5152607ae8ddb2a98a53d",
		"abbreviation": "Ltd",
		"address": "Vatos Parelion",
		"agencyName": "CG Villas",
		"agency_id": 46,
		"city": "Vatos",
		"countryCode": "GR",
		"createdAt": "2023-01-20T17:24:19.491Z",
		"email": "info@cgvillas.com",
		"firstName": "Annamie Doukakis",
		"phone": "6978968624",
		"state_province": "Corfu",
		"ta_company_markup": "0",
		"updatedAt": "2023-03-29T07:12:06.349Z",
		"website": "https://cgvillas.com/"
	},
	{
		"_id": "63e5152607ae8ddb2a98a53e",
		"abbreviation": "Ltd",
		"address": "M 111, Monte Pelvoux",
		"agencyName": "Exmar Turismo",
		"agency_id": 47,
		"city": "Mexico City",
		"countryCode": "MX",
		"createdAt": "2023-01-20T17:24:19.491Z",
		"email": "arosete@texmar.com",
		"firstName": "Ana ROSETE",
		"phone": "5.2556E+11",
		"state_province": "Mexico CDMX",
		"ta_company_markup": "0",
		"updatedAt": "2023-03-29T07:12:06.350Z",
		"website": "turismoexmar.com"
	},
	{
		"_id": "63e5152607ae8ddb2a98a53f",
		"abbreviation": "Ltd",
		"address": "Route de la Chapelle 7",
		"agencyName": "TBC",
		"agency_id": 48,
		"city": "La Lécherette",
		"countryCode": "CH",
		"createdAt": "2023-01-20T17:24:19.491Z",
		"email": "nick@nickguisan.ch",
		"firstName": "Nicolas Guisan",
		"phone": "41795521916",
		"state_province": "Vaud",
		"ta_company_markup": "10",
		"updatedAt": "2023-03-29T07:12:06.350Z"
	},
	{
		"_id": "63e5152607ae8ddb2a98a540",
		"abbreviation": "LTDA",
		"address": "AV EUROPA, 367",
		"agencyName": "SKI BRASIL VIAGENS E TURISMO",
		"agency_id": 49,
		"city": "São Paulo",
		"countryCode": "BR",
		"createdAt": "2023-01-20T17:24:19.491Z",
		"email": "produtos@ttwgroup.com",
		"firstName": "Renata Higa",
		"phone": "55 11 2196-9399",
		"state_province": "São Paulo",
		"ta_company_markup": "10",
		"updatedAt": "2023-03-29T07:12:06.350Z",
		"website": "https://www.skibrasil.com.br/pt"
	},
	{
		"_id": "63e5152607ae8ddb2a98a541",
		"abbreviation": "LTDA",
		"address": "1548 Brickell Avenue",
		"agencyName": "SKIUSA",
		"agency_id": 50,
		"city": "Miami",
		"countryCode": "US",
		"createdAt": "2023-01-20T17:24:19.491Z",
		"email": "produtos@ttwgroup.com",
		"firstName": "Caroline Brandao",
		"phone": "+1 305 735 8488",
		"state_province": "Florida",
		"ta_company_markup": "10",
		"updatedAt": "2023-03-29T07:12:06.350Z",
		"website": "https://www.skiusa.com/pt"
	},
	{
		"_id": "63e5152607ae8ddb2a98a542",
		"abbreviation": "SARL",
		"address": "22 Boulevard Albert Einstein",
		"agencyName": "BAZIHOUSE",
		"agency_id": 51,
		"city": "Nantes",
		"countryCode": "FR",
		"createdAt": "2023-01-20T17:24:19.491Z",
		"email": "contact@bazihouse-conciergerie.com",
		"firstName": "BASILA THOMAS",
		"phone": "+33 6 34 39 14 05",
		"state_province": "Loire-Atlantique",
		"ta_company_markup": "0",
		"updatedAt": "2023-03-29T07:12:06.350Z",
		"website": "https://bazihouse-conciergerie.com"
	},
	{
		"_id": "63e5152607ae8ddb2a98a543",
		"abbreviation": "AG",
		"address": "Mettlenstr. 16",
		"agencyName": "Smiling House",
		"agency_id": 55,
		"city": "Gstaad",
		"countryCode": "CH",
		"createdAt": "2023-01-20T17:24:19.491Z",
		"email": "jben.lang@gmail.com",
		"firstName": "Ben Israel",
		"ta_company_markup": "10",
		"updatedAt": "2023-03-29T07:12:06.351Z",
		"website": "www.smilinghouse.ch"
	},
	{
		"_id": "63e5152607ae8ddb2a98a544",
		"abbreviation": "Ltd",
		"address": "AABC 210, Suite AA",
		"agencyName": "Ski.com",
		"agency_id": 57,
		"city": "Aspen",
		"countryCode": "US",
		"createdAt": "2023-01-20T17:24:19.491Z",
		"email": "john@ski.com",
		"firstName": "John Frasca",
		"phone": "-11394",
		"state_province": "CO",
		"ta_company_markup": "10",
		"updatedAt": "2023-03-29T07:12:06.351Z",
		"website": "www.ski.com"
	},
	{
		"_id": "63e5152607ae8ddb2a98a545",
		"abbreviation": "LLC",
		"address": "Suite 450, 390 Interlocken Resort",
		"agencyName": "The Quintess Collection",
		"agency_id": 58,
		"city": "Broomfieled",
		"countryCode": "US",
		"createdAt": "2023-01-20T17:24:19.491Z",
		"email": "rmcfadden@quintess.com",
		"firstName": "Ronan McFadden",
		"phone": "33637195056+",
		"state_province": "Colorado",
		"ta_company_markup": "10",
		"updatedAt": "2023-03-29T07:12:06.351Z",
		"website": "quintess.com"
	},
	{
		"_id": "63e5152607ae8ddb2a98a546",
		"abbreviation": "SA",
		"address": "Profsoyuznaya str.,3",
		"agencyName": "Alpenglueck",
		"agency_id": 59,
		"city": "Moscow",
		"countryCode": "RU",
		"createdAt": "2023-01-20T17:24:19.491Z",
		"email": "inna.yagodkina@alpenglueck.ru",
		"firstName": "Mrs Inna Yagodkina",
		"phone": "74957810205",
		"state_province": "Moscow",
		"ta_company_markup": "10",
		"updatedAt": "2023-03-29T07:12:06.395Z",
		"website": "www.alpenglueck.ru"
	}
];
export const data = [
	{
		id: "9s41rp",
		agencyName: "Kelvin",
		manager: "Langosh ARNON",
		email: "Jerod14@hotmail.com",
		status: 'pending',
		approvedAt: '22.02.2022',
		firstSignIn: '22.02.2022',
		lastSignIn: '22.02.2022',
		subAgent: 19,
		country: "Ohio",
		phone: "+41-79-489-7021",
	},
	{
		id: "08m6rx",
		agencyName: "Molly",
		manager: "Purdy",
		email: "Hugh.Dach79@hotmail.com",
		status: 'pending',
		approvedAt: '22.02.2022',
		firstSignIn: '22.02.2022',
		lastSignIn: '22.02.2022',
		subAgent: 37,
		country: "Rhode Island",
		phone: "+41-79-489-7021",
	},
	{
		id: "5ymtrc",
		agencyName: "Henry",
		manager: "Lynch",
		email: "Camden.Macejkovic@yahoo.com",
		status: 'pending',
		approvedAt: '22.02.2022',
		firstSignIn: '22.02.2022',
		lastSignIn: '22.02.2022',
		subAgent: 20,
		country: "California",
		phone: "+41-79-489-7021",
	},
	{
		id: "ek5b97",
		agencyName: "Glenda",
		manager: "Douglas",
		email: "Eric0@yahoo.com",
		status: 'pending',
		approvedAt: '22.02.2022',
		firstSignIn: '22.02.2022',
		lastSignIn: '22.02.2022',
		subAgent: 38,
		country: "Montana",
		phone: "+41-79-489-7021",
	},
	{
		id: "xxtydd",
		agencyName: "Leone",
		manager: "Williamson",
		email: "Ericka_Mueller52@yahoo.com",
		status: 'pending',
		approvedAt: '22.02.2022',
		firstSignIn: '22.02.2022',
		lastSignIn: '22.02.2022',
		subAgent: 19,
		country: "Colorado",
		phone: "+41-79-489-7021",
	},
	{
		id: "wzxj9m",
		agencyName: "Mckenna",
		manager: "Friesen",
		email: "Veda_Feeney@yahoo.com",
		status: 'pending',
		approvedAt: '22.02.2022',
		firstSignIn: '22.02.2022',
		lastSignIn: '22.02.2022',
		subAgent: 34,
		country: "New York",
		phone: "+41-79-489-7021",
	},
	{
		id: "21dwtz",
		agencyName: "Wyman",
		manager: "Jast",
		email: "Melvin.Pacocha@yahoo.com",
		status: 'pending',
		approvedAt: '22.02.2022',
		firstSignIn: '22.02.2022',
		lastSignIn: '22.02.2022',
		subAgent: 23,
		country: "Montana",
		phone: "+41-79-489-7021",
	},
	{
		id: "o8oe4k",
		agencyName: "Janick",
		manager: "Willms",
		email: "Delfina12@gmail.com",
		status: 'pending',
		approvedAt: '22.02.2022',
		firstSignIn: '22.02.2022',
		lastSignIn: '22.02.2022',
		subAgent: 25,
		country: "Nebraska",
		phone: "+41-79-489-7021",
	},
	{
		id: "9s41rp1",
		agencyName: "Kelvin",
		manager: "Langosh",
		email: "Jerod14@hotmail.com",
		status: 'pending',
		approvedAt: '22.02.2022',
		firstSignIn: '22.02.2022',
		lastSignIn: '22.02.2022',
		subAgent: 19,
		country: "Ohio",
		phone: "+41-79-489-7021",
	},
	{
		id: "08m6rx1",
		agencyName: "Molly",
		manager: "Purdy",
		email: "Hugh.Dach79@hotmail.com",
		status: 'pending',
		approvedAt: '22.02.2022',
		firstSignIn: '22.02.2022',
		lastSignIn: '22.02.2022',
		subAgent: 37,
		country: "Rhode Island",
		phone: "+41-79-489-7021",
	},
	{
		id: "5ymtrc1",
		agencyName: "Henry",
		manager: "Lynch",
		email: "Camden.Macejkovic@yahoo.com",
		status: 'pending',
		approvedAt: '22.02.2022',
		firstSignIn: '22.02.2022',
		lastSignIn: '22.02.2022',
		subAgent: 20,
		country: "California",
		phone: "+41-79-489-7021",
	},
	{
		id: "ek5b971",
		agencyName: "Glenda",
		manager: "Douglas",
		email: "Eric0@yahoo.com",
		status: 'pending',
		approvedAt: '22.02.2022',
		firstSignIn: '22.02.2022',
		lastSignIn: '22.02.2022',
		subAgent: 38,
		country: "Montana",
		phone: "+41-79-489-7021",
	},
	{
		id: "xxtydd1",
		agencyName: "Leone",
		manager: "Williamson",
		email: "Ericka_Mueller52@yahoo.com",
		status: 'pending',
		approvedAt: '22.02.2022',
		firstSignIn: '22.02.2022',
		lastSignIn: '22.02.2022',
		subAgent: 19,
		country: "Colorado",
		phone: "+41-79-489-7021",
	},
	{
		id: "wzxj9m1",
		agencyName: "Mckenna",
		manager: "Friesen",
		email: "Veda_Feeney@yahoo.com",
		status: 'pending',
		approvedAt: '22.02.2022',
		firstSignIn: '22.02.2022',
		lastSignIn: '22.02.2022',
		subAgent: 34,
		country: "New York",
		phone: "+41-79-489-7021",
	},
	{
		id: "21dwtz1",
		agencyName: "Wyman",
		manager: "Jast",
		email: "Melvin.Pacocha@yahoo.com",
		status: 'pending',
		approvedAt: '22.02.2022',
		firstSignIn: '22.02.2022',
		lastSignIn: '22.02.2022',
		subAgent: 23,
		country: "Montana",
		phone: "+41-79-489-7021",
	},
	{
		id: "o8oe4k1",
		agencyName: "Janick",
		manager: "Willms",
		email: "Delfina12@gmail.com",
		status: 'pending',
		approvedAt: '22.02.2022',
		firstSignIn: '22.02.2022',
		lastSignIn: '22.02.2022',
		subAgent: 25,
		country: "Nebraska",
		phone: "+41-79-489-7021",
	},
	{
		id: "9s41rp2",
		agencyName: "Kelvin",
		manager: "Langosh",
		email: "Jerod14@hotmail.com",
		status: 'pending',
		approvedAt: '22.02.2022',
		firstSignIn: '22.02.2022',
		lastSignIn: '22.02.2022',
		subAgent: 19,
		country: "Ohio",
		phone: "+41-79-489-7021",
	},
	{
		id: "08m6rx2",
		agencyName: "Molly",
		manager: "Purdy",
		email: "Hugh.Dach79@hotmail.com",
		status: 'pending',
		approvedAt: '22.02.2022',
		firstSignIn: '22.02.2022',
		lastSignIn: '22.02.2022',
		subAgent: 37,
		country: "Rhode Island",
		phone: "+41-79-489-7021",
	},
	{
		id: "5ymtrc2",
		agencyName: "Henry",
		manager: "Lynch",
		email: "Camden.Macejkovic@yahoo.com",
		status: 'pending',
		approvedAt: '22.02.2022',
		firstSignIn: '22.02.2022',
		lastSignIn: '22.02.2022',
		subAgent: 20,
		country: "California",
		phone: "+41-79-489-7021",
	},
	{
		id: "ek5b972",
		agencyName: "Glenda",
		manager: "Douglas",
		email: "Eric0@yahoo.com",
		status: 'pending',
		approvedAt: '22.02.2022',
		firstSignIn: '22.02.2022',
		lastSignIn: '22.02.2022',
		subAgent: 38,
		country: "Montana",
		phone: "+41-79-489-7021",
	},
	{
		id: "xxtydd2",
		agencyName: "Leone",
		manager: "Williamson",
		email: "Ericka_Mueller52@yahoo.com",
		status: 'pending',
		approvedAt: '22.02.2022',
		firstSignIn: '22.02.2022',
		lastSignIn: '22.02.2022',
		subAgent: 19,
		country: "Colorado",
		phone: "+41-79-489-7021",
	},
	{
		id: "wzxj9m2",
		agencyName: "Mckenna",
		manager: "Friesen",
		email: "Veda_Feeney@yahoo.com",
		status: 'pending',
		approvedAt: '22.02.2022',
		firstSignIn: '22.02.2022',
		lastSignIn: '22.02.2022',
		subAgent: 34,
		country: "New York",
		phone: "+41-79-489-7021",
	},
	{
		id: "21dwtz2",
		agencyName: "Wyman",
		manager: "Jast",
		email: "Melvin.Pacocha@yahoo.com",
		status: 'pending',
		approvedAt: '22.02.2022',
		firstSignIn: '22.02.2022',
		lastSignIn: '22.02.2022',
		subAgent: 23,
		country: "Montana",
		phone: "+41-79-489-7021",
	},
	{
		id: "o8oe4k2",
		agencyName: "Janick",
		manager: "Willms",
		email: "Delfina12@gmail.com",
		status: 'pending',
		approvedAt: '22.02.2022',
		firstSignIn: '22.02.2022',
		lastSignIn: '22.02.2022',
		subAgent: 25,
		country: "Nebraska",
		phone: "+41-79-489-7021",
	},
	{
		id: "9s41rp3",
		agencyName: "Kelvin",
		manager: "Langosh",
		email: "Jerod14@hotmail.com",
		status: 'pending',
		approvedAt: '22.02.2022',
		firstSignIn: '22.02.2022',
		lastSignIn: '22.02.2022',
		subAgent: 19,
		country: "Ohio",
		phone: "+41-79-489-7021",
	},
	{
		id: "08m6rx3",
		agencyName: "Molly",
		manager: "Purdy",
		email: "Hugh.Dach79@hotmail.com",
		status: 'pending',
		approvedAt: '22.02.2022',
		firstSignIn: '22.02.2022',
		lastSignIn: '22.02.2022',
		subAgent: 37,
		country: "Rhode Island",
		phone: "+41-79-489-7021",
	},
	{
		id: "5ymtrc3",
		agencyName: "Henry",
		manager: "Lynch",
		email: "Camden.Macejkovic@yahoo.com",
		status: 'pending',
		approvedAt: '22.02.2022',
		firstSignIn: '22.02.2022',
		lastSignIn: '22.02.2022',
		subAgent: 20,
		country: "California",
		phone: "+41-79-489-7021",
	},
	{
		id: "ek5b973",
		agencyName: "Glenda",
		manager: "Douglas",
		email: "Eric0@yahoo.com",
		status: 'pending',
		approvedAt: '22.02.2022',
		firstSignIn: '22.02.2022',
		lastSignIn: '22.02.2022',
		subAgent: 38,
		country: "Montana",
		phone: "+41-79-489-7021",
	},
	{
		id: "xxtydd3",
		agencyName: "Leone",
		manager: "Williamson",
		email: "Ericka_Mueller52@yahoo.com",
		status: 'pending',
		approvedAt: '22.02.2022',
		firstSignIn: '22.02.2022',
		lastSignIn: '22.02.2022',
		subAgent: 19,
		country: "Colorado",
		phone: "+41-79-489-7021",
	},
	{
		id: "wzxj9m3",
		agencyName: "Mckenna",
		manager: "Friesen",
		email: "Veda_Feeney@yahoo.com",
		status: 'pending',
		approvedAt: '22.02.2022',
		firstSignIn: '22.02.2022',
		lastSignIn: '22.02.2022',
		subAgent: 34,
		country: "New York",
		phone: "+41-79-489-7021",
	},
	{
		id: "21dwtz3",
		agencyName: "Wyman",
		manager: "Jast",
		email: "Melvin.Pacocha@yahoo.com",
		status: 'pending',
		approvedAt: '22.02.2022',
		firstSignIn: '22.02.2022',
		lastSignIn: '22.02.2022',
		subAgent: 23,
		country: "Montana",
		phone: "+41-79-489-7021",
	},
	{
		id: "o8oe4k3",
		agencyName: "Janick",
		manager: "Willms",
		email: "Delfina12@gmail.com",
		status: 'pending',
		approvedAt: '22.02.2022',
		firstSignIn: '22.02.2022',
		lastSignIn: '22.02.2022',
		subAgent: 25,
		country: "Nebraska",
		phone: "+41-79-489-7021",
	}
];

//50 us countrys array
export const countrys = [
  "Alabama",
  "Alaska",
  "Arizona",
  "Arkansas",
  "California",
  "Colorado",
  "Connecticut",
  "Delaware",
  "Florida",
  "Georgia",
  "Hawaii",
  "Idaho",
  "Illinois",
  "Indiana",
  "Iowa",
  "Kansas",
  "Kentucky",
  "Louisiana",
  "Maine",
  "Maryland",
  "Massachusetts",
  "Michigan",
  "Minnesota",
  "Mississippi",
  "Missouri",
  "Montana",
  "Nebraska",
  "Nevada",
  "New Hampshire",
  "New Jersey",
  "New Mexico",
  "New York",
  "North Carolina",
  "North Dakota",
  "Ohio",
  "Oklahoma",
  "Oregon",
  "Pennsylvania",
  "Rhode Island",
  "South Carolina",
  "South Dakota",
  "Tennessee",
  "Texas",
  "Utah",
  "Vermont",
  "Virginia",
  "Washington",
  "West Virginia",
  "Wisconsin",
  "Wyoming",
  "Puerto Rico",
];
